/**
 * Раскладка во весь экран — Fullscreen API браузера. Узел — DOM-элемент, которым на
 * вебе и является `View` (react-native-web рисует через react-dom).
 *
 * Обещания глотаются: браузер отказывает без жеста пользователя или в iframe, и
 * отказ — это просто «не развернулось», а не поломка просмотра.
 */
export const CAN_FULLSCREEN =
  typeof document !== 'undefined' && document.fullscreenEnabled === true;

export function toggleFullscreen(node: unknown): void {
  if (typeof document === 'undefined') {
    return;
  }
  if (document.fullscreenElement) {
    void document.exitFullscreen().catch(() => {});
    return;
  }
  const el = node as HTMLElement | null;
  void el?.requestFullscreen?.().catch(() => {});
}
